import { baseApi } from "api/BaseApi";
import { PaginatedResponse } from "api/common/types/response.types";

import type {
  ProductUpdatePcm,
  ProductUpdateCreatePayload,
  ProductUpdateEditPayload,
  ProductUpdateListFilterParams,
  ProductUpdatePathParams,
} from "./productUpdate.types";

const PCM_BASE_QUERY = "/pcm";

const productUpdatePcmApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    // CREATE
    createProductUpdatePcm: build.mutation<
      ProductUpdatePcm,
      ProductUpdateCreatePayload
    >({
      query: ({ parentId, body }) => ({
        url: `${PCM_BASE_QUERY}/${parentId}/updates/`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["PRODUCT_UPDATES"],
    }),

    // LIST
    listProductUpdatesPcm: build.query<
      ProductUpdatePcm[],
      ProductUpdateListFilterParams
    >({
      query: ({ parentId, active }) => ({
        url: `${PCM_BASE_QUERY}/${parentId}/updates/`,
        params: { active },
      }),
      transformResponse: (result: PaginatedResponse<ProductUpdatePcm>) =>
        result.results,
      providesTags: ["PRODUCT_UPDATES"],
    }),

    // RETRIEVE // NOTE: productUpdate already exists in product.api so adding get avoids namespace collision
    getProductUpdatePcm: build.query<ProductUpdatePcm, ProductUpdatePathParams>(
      {
        query: ({ parentId, updateId }) => ({
          url: `${PCM_BASE_QUERY}/${parentId}/updates/${updateId}/`,
        }),
      },
    ),

    // UPDATE
    updateProductUpdatePcm: build.mutation<
      ProductUpdatePcm,
      ProductUpdateEditPayload
    >({
      query: ({ parentId, updateId, body }) => ({
        url: `${PCM_BASE_QUERY}/${parentId}/updates/${updateId}/`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: ["PRODUCT_UPDATES"],
    }),

    // DELETE
    deleteProductUpdatePcm: build.mutation<void, ProductUpdatePathParams>({
      query: ({ parentId, updateId }) => ({
        url: `${PCM_BASE_QUERY}/${parentId}/updates/${updateId}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["PRODUCT_UPDATES"],
    }),
  }),

  overrideExisting: false,
});

export const {
  useCreateProductUpdatePcmMutation,
  useGetProductUpdatePcmQuery,
  useListProductUpdatesPcmQuery,
  useUpdateProductUpdatePcmMutation,
  useDeleteProductUpdatePcmMutation,
} = productUpdatePcmApi;
